// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (min-width:950px){
    .customer-user-container{
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
        background-color: white;
        position: absolute;
        top: 2vh;
        right: 0px;
        height: 95%;
        width: 70%;
        box-sizing: border-box;
        border-radius: 5px 0px 0px 5px;
    }
    .customer-user-container-header{
        color: white;
        background-color: rgba(155, 30, 30, 0.952);
        padding: 15px;
        border-radius: 5px 0px 0px 0px;
        display: flex;
        justify-content: space-between;
    }
    .customer-user-container-header h3{
        margin: 0px;
        font-weight: lighter;
    }
    .customer-user-container-header p{
        margin: 0px;
        margin-right: 20px;
        font-weight: lighter;
        font-size: 30px;
        cursor: pointer;
    }
    .customer-user-container-header h4{
        margin: 0px;
        font-weight: lighter;
        font-size: 14px;
    }
    .customer-user-container-navigation-bar{
        padding: 10px 20px;
        border-bottom: 1px solid rgb(211, 210, 210);
    }
    .customer-user-container-navigation-bar button{
        margin-right: 20px;
        border: none;
        outline: none;
        cursor: pointer;
        text-wrap: nowrap;
        padding: 8px 16px;
        border-radius: 80px;
        background-color: transparent;
        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
    }
    .customer-user-details-container-navigation-bar{
        position: relative;
        padding: 20px;
    }
    .customer-user-details-container-navigation-bar button{
        margin-right: 20px;
        padding: 8px 12px;
        border: none;
        border-radius: 5px;
        color: white;
        cursor: pointer;
        background-color: rgba(155, 30, 30, 0.952);
        box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.5);
        transition: background-color 0.5s ease;
    }
    .customer-user-details-container-navigation-bar button:hover{
        background-color: rgba(187, 35, 35, 0.952);
    }
    #edit-icon,#discard-changes-icon,#save-changes-icon.active{
        position: absolute;
        top: 10px;
        border-radius: 50%;
        background-color: rgba(233, 77, 30, 0.952);
    }
    #save-changes-icon.inactive{
        position: absolute;
        top: 10px;
        border-radius: 50%;
        cursor: not-allowed;
        opacity: 0.7;
        box-shadow: 0px 0px 2px rgba(255, 255, 255, 0);
        background-color: rgb(219, 219, 219);
    }
    #discard-changes-icon{
        right: 40px;
        padding: 10px 14px;
    }
    #save-changes-icon{
        right: 100px;
        padding: 11px 15px;
    }
    #edit-icon{
        right: 40px;
        padding: 8px 10px;
    }
    #edit-icon img{
        height: 20px;
    }
}
@media screen and (max-width:949px){
    .customer-user-container{
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
        background-color: white;
        position: absolute;
        top: 0vh;
        right: 0px;
        height: 100%;
        width: 100%;
        box-sizing: border-box;
        border-radius: 10px;
    }
    .customer-user-container-header{
        color: white;
        background-color: rgba(155, 30, 30, 0.952);
        padding: 15px;
        border-radius: 10px 10px 0px 0px;
        display: flex;
        justify-content: space-between;
    }
    .customer-user-container-header h3{
        margin: 0px;
        font-size: 16px;
        font-weight: lighter;
    }
    .customer-user-container-header p{
        margin: 0px;
        cursor: pointer;
        font-size: 20px;
        margin-top: -6px;
        margin-right: 10px;
        box-sizing: border-box;
        font-weight: lighter;
    }
    .customer-user-container-header h4{
        margin: 0px;
        font-weight: lighter;
        font-size: 13px;
    }
    .customer-user-details-container-navigation-bar{
        padding: 20px;
        width: 100%;
        display: flex;
        overflow: auto;
        align-items: center;
        box-sizing: border-box;
        padding: 20px!important;
        box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.2);
    }
    .customer-user-details-container-navigation-bar button{
        margin-right: 20px;
        padding: 8px 12px;
        border: none;
        border-radius: 5px;
        color: white;
        cursor: pointer;
        white-space: nowrap;
        background-color: rgba(155, 30, 30, 0.952);
        box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.5);
        transition: background-color 0.5s ease;
    }
    .customer-user-details-container-navigation-bar button:hover{
        background-color: rgba(187, 35, 35, 0.952);
    }
    #edit-icon,#discard-changes-icon,#save-changes-icon{
        display: none!important;
    }
}
.customer-user-details-container-body{
    max-height: 55vh;
    overflow: auto;
    padding: 0px 20px;
}
.customer-user-details-container-body::-webkit-scrollbar{
    width: 5px;
}
.customer-user-details-container-body::-webkit-scrollbar-thumb{
    border-radius: 5px;
    background-color: rgba(0, 0, 0, 0.2);
}
.customer-user-details-container-body-component{
    margin: 20px;
    padding: 5px 10px;
    position: relative;
    background-color: rgba(222, 229, 233,0.6);
    border-bottom: 1px solid gray;
    border-radius: 2px 2px 0px 0px;
}
.customer-user-details-container-body-component.edit:focus-within{
    border-bottom: 2px solid rgb(119, 12, 12);
    background-color: rgb(221, 232, 238);
}
.customer-user-details-container-body-component p{
    margin: 0px;
    font-size: 10px;
    cursor: default;
    background-color: transparent;
}
.customer-user-details-container-body-component span{
    color: red;
}
.customer-user-details-container-body-component input{
    margin: 0px;
    outline: none;
    border: none;
    width: 100%;
    cursor: default;
    background-color: transparent;
}
.customer-user-details-container-body-component.edit input{
    cursor: text;
}
.customer-user-details-container-body-component-country-display{
    display: flex;
    justify-content: space-between;
}
.customer-user-details-container-body-component-country-display p{
    font-size: 14px;
    margin: 2px 0px;
}
.customer-user-details-container-body-component-country-display .cancel-p{
    display: none;
}
.customer-user-details-container-body-component-country-display.edit .cancel-p{
    display: block;
    cursor: pointer;
    color: rgb(54, 54, 54);
}
.customer-user-details-container-body-component-countries-browser{
    position: absolute;
    top: calc(100% + 2px);
    left: 0;
    right: 0;
    z-index: 1;
    display: none;
    overflow: auto;
    max-height: 17vh;
    background-color: white;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
}
.customer-user-details-container-body-component-countries-browser.active{
    display: block;
}
.customer-user-details-container-body-component-countries-browser::-webkit-scrollbar{
    width: 4px;
}
.customer-user-details-container-body-component-countries-browser::-webkit-scrollbar-thumb{
    border-radius: 5px;
    background-color: gray;
}
.customer-user-details-container-body-component-countries-browser div{
    padding: 5px 16px;
    font-size: 14px;
    cursor: pointer;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    border: 1px solid rgb(250, 250, 250);
}
.customer-user-details-container-body-component-countries-browser div:hover{
    background-color: rgb(221, 232, 238);
}
.customer-user-details-container-body-component select{
    margin: 0px;
    width: 100%;
    border: none;
    outline: none;
    padding: 2px 0px;
    background-color: transparent;
}
.customer-user-details-dashboard-settings-container{
    display: grid;
    padding: 0px 20px;
    grid-template-columns: 1fr 1fr;
}
.customer-user-details-default-dashboard-selection-container{
    width: 80%;
}
.customer-user-details-default-dashboard-selection-container p{
    margin: 0px;
    font-size: 12px;
    cursor: default;
}
.customer-user-details-default-dashboard-selection-container select{
    width: 100%;
    margin: 0px;
    margin-top: 5px;
    padding: 6px 12px;
    border: none;
    outline: none;
    border-radius: 2px;
    background-color: rgb(222, 229, 233);
    border-bottom: 1px solid rgb(163, 163, 163);
}
.customer-user-details-default-dashboard-show-full-screen-container{
    display: flex;
    align-items: center;
    padding-top: 10px;
}
.customer-user-details-default-dashboard-show-full-screen-container p{
    margin: 0px;
    font-size: 14px;
    cursor: default;
    color: rgb(100, 100, 100);
}
.customer-user-details-default-dashboard-show-full-screen-container img{
    height: 20px;
    margin: 15px 30px;
}

.customer-user-billing-account-missing-container-wrapper{
    margin-top: 6vh;
    display: flex;
    justify-content: center;
}
.customer-user-billing-account-missing-container{
    padding: 15px 25px;
    border-radius: 10px;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.2);
    opacity: 0;
    transform: translateY(-20px);
    animation: customer-user-billing-account-missing-container-fade-in 0.8s ease-out forwards;
}
@keyframes customer-user-billing-account-missing-container-fade-in {
    from {
        opacity: 0;
        transform: translateY(-20px);
    }
    to{
        opacity: 1;
        transform: translateY(0);
    }
}
.customer-user-billing-account-missing-header-container p{
    margin: 2px 0px;
    font-weight: 600;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    color: rgb(70, 70, 70);
}
.customer-user-billing-account-missing-body-container{
    padding: 8px 0px;
    padding-bottom: 20px;
}
.customer-user-billing-account-missing-body-container p{
    margin: 2px 0px;
    font-size: 14px;
    color: rgb(51, 51, 51);
}
.customer-user-billing-account-missing-button-container{
    display: flex;
    justify-content: flex-end;
}
.customer-user-billing-account-missing-button-container button{
    padding: 8px 12px;
    border: none;
    border-radius: 5px;
    color: white;
    cursor: pointer;
    background-color: rgba(155, 30, 30, 0.952);
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
    transition: background-color 0.5s ease,transform 0.2s ease;
    transform-origin: center center;
}
.customer-user-billing-account-missing-button-container button:hover{
    background-color: rgba(196, 37, 37, 0.952);
    transform: scale(1.10);
}

.customer-user-billing-account-creating-container{
    margin-top: 5vh;
    padding: 15px 35px;
    border-radius: 10px;
    box-shadow: 0px 2px 8px rgba(0, 0, 0,0.2);
    opacity: 0;
    transform: translateY(-20px);
    animation: customer-user-billing-account-creating-container-fade-in 0.8s linear forwards;
}
@keyframes customer-user-billing-account-creating-container-fade-in {
    from{
        opacity: 0;
        transform: translateY(-20px);
    }
    to{
        opacity: 1;
        transform: translateY(0);
    }
}
.customer-user-billing-account-creating-container p{
    margin: 0px;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.customer-user-billing-account-creating-body{
    margin-top: 15px;
    margin-bottom: 5px;
}
.customer-user-billing-account-creating-body span{
    margin-left: 2px;
    color: rgb(77, 77, 77);
}
.customer-user-billing-account-creating-spinner-container{
    display: flex;
    justify-content: center;
}
.customer-user-billing-account-creating-spinner-container div{
    width: 40px;
    height: 40px;
    box-sizing: border-box;
    border: 5px solid rgba(155, 30, 30, 0.952);
    border-top: 5px solid transparent;
    border-radius: 50%;
    animation: customer-user-billing-account-creating-spinner 1s linear infinite;
}
@keyframes customer-user-billing-account-creating-spinner {
    from{transform: rotate(0deg);}
    to{transform: rotate(360deg);}
}
.customer-user-billing-account-created-container{
    margin-top: 5vh;
    padding: 15px 35px;
    border-radius: 10px;
    box-shadow: 0px 2px 8px rgba(0, 0, 0,0.2);
    opacity: 0;
    transform: translateY(-20px);
    animation: customer-user-billing-account-created-container-fade-in 0.8s linear forwards;
}
@keyframes customer-user-billing-account-created-container-fade-in{
    from{
        opacity: 0;
        transform: translateY(-20px);
    }
    to{
        opacity: 1;
        transform: translateY(0);
    }
}
.customer-user-billing-account-created-container p{
    margin: 4px 0px;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.customer-user-billing-account-created-container .title-paragraph{
    font-weight: 600;
    color: rgb(70, 70, 70);
}
.customer-user-billing-account-created-container .message-paragraph{
    font-weight: 400;
    color: rgb(51, 51, 51);
}
.customer-user-billing-account-created-container div{
    margin-top: 15px;
    display: flex;
    justify-content: flex-end;
}
.customer-user-billing-account-created-container div button{
    padding: 8px 16px;
    border: none;
    border-radius: 5px;
    color: white;
    cursor: pointer;
    background-color: rgba(155, 30, 30, 0.952);
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
    transition: background-color 0.5s ease,transform 0.2s ease;
    transform-origin: center center;
}
.customer-user-billing-account-created-container div button:hover{
    transform: scale(1.10);
    background-color: rgba(196, 37, 37, 0.952);
}
.customer-user-billing-account-management-navigation-bar{
    padding: 8px 5px;
    border-bottom: 1px solid rgb(168, 168, 168);
}
.customer-user-billing-account-management-navigation-bar button{
    margin: 0px 12px;
    padding: 8px 12px;
    border: none;
    border-radius: 5px;
    color: white;
    cursor: pointer;
    background-color: rgba(155, 30, 30, 0.952);
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.2);
    transition: background-color 0.5s ease;
}
.customer-user-billing-account-management-navigation-bar button.active{
    background-color: rgb(0, 125, 0);
}
.customer-user-billing-account-management-navigation-bar button:hover{
    background-color: rgba(196, 37, 37, 0.952);
}
.customer-user-billing-account-management-navigation-bar button.active:hover{
    background-color: rgb(0, 165, 0);
}
.customer-user-billing-account-summary-container{
    padding: 10px 20px;
}
.customer-user-billing-account-details-parent-container{
    display: flex;
}
.customer-user-billing-account-details-container{
    padding: 15px 25px;
    border-radius: 4px;
    margin-right: 10px;
    display: inline-block;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.2);
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    opacity: 0;
    transform: translateX(-20px);
    animation: customer-user-billing-account-details-container-fade-in 0.8s linear forwards;
}
@keyframes customer-user-billing-account-details-container-fade-in{
    from{
        opacity: 0;
        transform: translateX(-20px);
    }
    to{
        opacity: 1;
        transform: translateX(0);
    }
}
.customer-user-billing-account-details-container.account-no{
    padding-left: 38px;
    padding-right: 38px;
}
.customer-user-billing-account-account-number-header,
.customer-user-billing-account-balance-header{
    margin: 0px;
    font-weight: 600;
}
.customer-user-billing-account-account-number-paragraph{
    margin: 10px 0px;
    font-weight: 600;
    font-size: 26px;
    color: rgb(212, 145, 0);
}
.customer-user-billing-account-delete-account-paragraph{
    text-align: right;
    font-size: 16px;
    cursor: pointer;
    font-weight: 500;
    color: rgb(194, 0, 0);
}
.customer-user-billing-account-balance-paragraph{
    margin: 10px 0px;
    color: rgb(161, 161, 161);
    font-weight: 600;
    font-size: 26px;
}
.customer-user-billing-account-date-time-created-container{
    display: grid;
    grid-template-columns: 1.5fr 1fr;
}
.customer-user-billing-account-date-time-created-container p{
    margin: 4px 0px;
}
.customer-user-billing-account-summary-no-transactions-container{
    margin-top: 15px;
    padding: 25px 20px;
    border-radius: 10px;
    display: inline-block;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.2);
    opacity: 0;
    transform: translateX(5vw);
    transition: opacity 0.8s ease;
    animation: customer-user-billing-account-summary-no-transaction-container-fade-in 0.8s linear forwards;
}
@keyframes customer-user-billing-account-summary-no-transaction-container-fade-in{
    from{
        opacity: 0;
        transform: translateX(5vw);
    }
    to{
        opacity: 1;
        transform: translateX(0);
    }
}
.customer-user-billing-account-summary-no-transactions-container p{
    margin: 0px;
}
/*Transaction cards*/
.customer-user-billing-account-summary-transaction-cards-container{
    display: grid;
    column-gap: 15px;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.customer-user-billing-account-summary-transaction-cards-container .transaction-card{
    padding: 10px;
    border-radius: 4px;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.2);
    opacity: 0;
    transform: translateY(4vh);
    animation: customer-user-billing-account-summary-transaction-card-fade-in 0.8s ease-out forwards;
}
@keyframes customer-user-billing-account-summary-transaction-card-fade-in{
    from{
        opacity: 0;
        transform: translateY(4vh);
    }
    to{
        opacity: 1;
        transform: translateY(0);
    }
}
.customer-user-billing-account-summary-transaction-cards-container .transaction-card-top-up-p,
.customer-user-billing-account-summary-transaction-cards-container .transaction-card-top-up-pending-p,
.customer-user-billing-account-summary-transaction-cards-container .transaction-card-top-up-failed-p,
.customer-user-billing-account-summary-transaction-cards-container .transaction-card-deduction-p{
    margin: 2px 0px;
    font-size: 15px;
    font-weight: 600;
    cursor: default;
}
.customer-user-billing-account-summary-transaction-cards-container .transaction-card-top-up-p{
    color: green;
}
.customer-user-billing-account-summary-transaction-cards-container .transaction-card-top-up-pending-p{
    color: orange;
}
.customer-user-billing-account-summary-transaction-cards-container .transaction-card-top-up-failed-p{
    color: red;
}
.customer-user-billing-account-summary-transaction-cards-container .transaction-card-top-up-type-p{
    margin: 4px 0px;
    font-size: 15px;
    cursor: default;
}
.customer-user-billing-account-summary-transaction-cards-container .transaction-card-top-up-amount-container{
    margin: 0px;
    margin-bottom: 5px;
    display: grid;
    grid-template-columns: 1fr 1fr;
}
.customer-user-billing-account-summary-transaction-cards-container .transaction-card-top-up-amount-container p{
    margin: 0px;
    cursor: default;
}
.customer-user-billing-account-summary-transaction-cards-container .transaction-card-top-up-date-container,
.customer-user-billing-account-summary-transaction-cards-container .transaction-card-top-up-time-container{
    margin: 0px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    cursor: default;
}
.customer-user-billing-account-summary-transaction-cards-container .transaction-card-top-up-date-container p,
.customer-user-billing-account-summary-transaction-cards-container .transaction-card-top-up-time-container p{
    margin: 0px;
    font-size: 14px;
    font-weight: 600;
    color: rgb(66, 66, 66);
}
.customer-user-billing-account-summary-transaction-cards-container .transaction-card-top-up-image-container{
    display: flex;
    justify-content: center;
}
.customer-user-billing-account-summary-transaction-cards-container .transaction-card-top-up-image-container img{
    width: 4vw;
    margin: 4vh 0px;
}
.customer-user-billing-account-summary-transaction-cards-container .transaction-card-deduction-p{
    color: red;
}
.customer-user-billing-account-summary-transaction-cards-container .transaction-card-deduction-desc-p{
    margin: 4px 0px;
    font-size: 15px;
    cursor: default;
}
.customer-user-billing-account-summary-transaction-cards-container .transaction-card-deduction-amount-container{
    margin: 0px;
    margin-bottom: 5px;
    display: grid;
    grid-template-columns: 1fr 1fr;
}
.customer-user-billing-account-summary-transaction-cards-container .transaction-card-deduction-amount-container p{
    margin: 2px 0px;
}
.customer-user-billing-account-summary-transaction-cards-container .transaction-card-deduction-date-container,
.customer-user-billing-account-summary-transaction-cards-container .transaction-card-deduction-time-container{
    margin: 0px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    cursor: default;
}
.customer-user-billing-account-summary-transaction-cards-container .transaction-card-deduction-date-container p,
.customer-user-billing-account-summary-transaction-cards-container .transaction-card-deduction-time-container p{
    margin: 0px;
    font-size: 14px;
    font-weight: 600;
    color: rgb(66, 66, 66);
}
.customer-user-billing-account-summary-transaction-cards-container .transaction-card-deduction-image-container{
    display: flex;
    justify-content: center;
}
.customer-user-billing-account-summary-transaction-cards-container .transaction-card-deduction-image-container img{
    width: 4vw;
    margin: 4vh 0px;
}
/*TRANSACTIONS SECTION*/
.customer-user-billing-account-transactions-table-container{
    margin: 4vh 4vw;
    position: relative;
    border-radius: 5px;
    max-height: 50vh;
    overflow-y: scroll;
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.customer-user-billing-account-transactions-sort-container{
    position: absolute;
    top: 4px;
    right: 20px;
    cursor: pointer;
}
.customer-user-billing-account-transactions-sort-container img{
    height: 20px;
}
.customer-user-billing-account-transactions-table-container table{
    width: 100%;
    table-layout: fixed;
    border-collapse: collapse;
}
.customer-user-billing-account-transaction-table-header-row{
    background-color: transparent!important;
}
.customer-user-billing-account-transactions-table-container table th,
.customer-user-billing-account-transactions-table-container table td{
    text-align: left;
    font-size: 16px;
    padding: 5px 10px;
}
.customer-user-billing-account-transactions-table-container table th{
    font-weight: 600;
}
.customer-user-billing-account-transactions-table-container table td{
    font-size: 15px;
}
.customer-user-billing-account-transactions-table-container tr:nth-child(odd){
    background-color: rgba(206, 206, 206,0.953);
}
.customer-user-billing-account-transactions-table-container tr:nth-child(even){
    background-color: rgb(242, 242, 242);
}
/*TOP UP SECTION*/
.customer-user-billing-account-top-up-container{
    max-height: 50vh;
    margin: 4vh 4vw;
    padding: 15px 20px;
    border-radius: 10px;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.2);
    opacity: 0;
    transform: translateY(-2vh);
    animation: customer-user-billing-account-top-up-container-fade-in 0.8s forwards;
}
@keyframes customer-user-billing-account-top-up-container-fade-in{
    from{
        opacity: 0;
        transform: translateY(-2vh);
    }
    to{
        opacity: 1;
        transform: translateY(0);
    }
}
.customer-user-billing-account-top-up-navigation-bar{
    padding: 10px 0px;
    border-bottom: 1px solid rgb(221, 221, 221);
}
.customer-user-billing-account-top-up-navigation-bar button{
    margin: 0px 12px;
    padding: 8px 12px;
    border: none;
    border-radius: 5px;
    color: white;
    cursor: pointer;
    background-color: rgba(155, 30, 30, 0.952);
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.5);
    transition: background-color 0.5s ease;
}
.customer-user-billing-account-top-up-navigation-bar button:hover{
    background-color: rgba(196, 37, 37, 0.952);
}
.customer-user-billing-account-top-up-body{
    height: auto;
    margin-top: 4px;
    margin-bottom: 2vh;
}
/**CASH TOP UP**/
.customer-user-billing-account-cash-top-up-entry-container{
    width: 45%;
    margin-left: 4vw;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.customer-user-billing-account-cash-top-up-entry-p{
    font-weight: 600;
}
.customer-user-billing-account-cash-top-up-entry-amount-container,
.customer-user-billing-account-cash-top-up-entry-currency-container{
    display: grid;
    grid-template-columns: 2fr 3fr;
    margin-bottom: 20px;
    padding: 5px 0px;
    align-items: center;
}
.customer-user-billing-account-cash-top-up-entry-amount-container p,
.customer-user-billing-account-cash-top-up-entry-currency-container p{
    margin: 0px;
}
.customer-user-billing-account-cash-top-up-entry-amount-container input{
    width: 84%;
    border: none;
    outline: none;
    padding: 10px 16px;
    border-radius: 4px;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.35);
}
.customer-user-billing-account-cash-top-up-entry-currency-container select{
    width: 96%;
    margin: 0px;
    padding: 10px;
    outline: none;
    border: none;
    border-radius: 4px;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.35);
}
.customer-user-billing-account-cash-top-up-entry-deposit-button-container{
    display: flex;
    justify-content: flex-end;
}
.customer-user-billing-account-cash-top-up-entry-deposit-button-container button{
    margin: 0px 12px;
    padding: 8px 12px;
    border: none;
    border-radius: 5px;
    color: white;
    cursor: pointer;
    background-color: rgba(155, 30, 30, 0.952);
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.5);
    transition: background-color 0.5s ease;
}
.customer-user-billing-account-cash-top-up-entry-deposit-button-container button:hover{
    background-color: rgba(196, 37, 37, 0.952);
}
.customer-user-billing-account-cash-topping-up-container{
    margin: 10vh 0;
    text-align: center;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.customer-user-billing-account-cash-topping-up-container .spinner{
    width: 30px;
    height: 30px;
    margin: auto;
    margin-bottom: 10px;
    border: 5px solid rgba(155, 30, 30, 0.952);
    border-top: 5px solid transparent;
    border-radius: 50%;
    animation: customer-billing-account-cash-topping-up-container-spin 1s linear infinite;
}
@keyframes customer-billing-account-cash-topping-up-container-spin {
    0% {transform: rotate(0deg);}
    100% {transform: rotate(360deg);}
}
.customer-user-billing-account-cash-top-up-success-container,
.customer-user-billing-account-cash-top-up-failed-container{
    margin: 50px 0px;
    margin-left: 2vw;
}
.customer-user-billing-account-cash-top-up-success-container .header-paragraph,
.customer-user-billing-account-cash-top-up-failed-container .header-paragraph{
    font-weight: 500;
    color: rgb(155, 30, 30);
}
.customer-user-billing-account-cash-top-up-success-container p,
.customer-user-billing-account-cash-top-up-failed-container p{
    margin: 20px 0px;
}
.customer-user-billing-account-cash-top-up-success-container button{
    margin-right: 25px;
    padding: 10px 16px;
    border: none;
    border-radius: 5px;
    color: white;
    cursor: pointer;
    background-color: rgba(155, 30, 30, 0.952);
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.5);
    transition: background-color 0.5s ease;
}
.customer-user-billing-account-cash-top-up-failed-container button{
    margin-right: 25px;
    padding: 8px 18px;
    border: none;
    border-radius: 5px;
    color: white;
    cursor: pointer;
    background-color: rgba(155, 30, 30, 0.952);
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.5);
    transition: background-color 0.5s ease;
}
.customer-user-billing-account-cash-top-up-success-container button:hover{
    background-color: rgba(196, 37, 37, 0.952);
}
/**MPESA TOP UP**/
.customer-user-billing-account-mpesa-top-up-entry-container{
    width: 48%;
    margin-left: 4vw;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.customer-user-billing-account-mpesa-top-up-entry-mobile-number-container,
.customer-user-billing-account-mpesa-top-up-entry-amount-container{
    display: grid;
    grid-template-columns: 0.6fr 1fr;
    margin-bottom: 24px;
    align-items: center;
}
.customer-user-billing-account-mpesa-top-up-entry-mobile-number-container p,
.customer-user-billing-account-mpesa-top-up-entry-amount-container p{
    margin: 0px;
}
.customer-user-billing-account-mpesa-top-up-entry-mobile-number-container label{
    margin-top: 2px;
    color: red;
    grid-column: 2;
    font-size: 14px;
    width: 96%;
    text-align: right;
}
.customer-user-billing-account-mpesa-top-up-entry-mobile-number-container input,
.customer-user-billing-account-mpesa-top-up-entry-amount-container input{
    border: none;
    outline: none;
    padding: 10px 15px;
    border-radius: 10px;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.4);
}
.customer-user-billing-account-mpesa-top-up-entry-stk-push-button-container{
    display: flex;
    justify-content: flex-end;
    padding: 10px 0px;
    padding-top: 15px;
}
.customer-user-billing-account-mpesa-top-up-entry-stk-push-button-container button{
    margin: 0px;
    padding: 8px 12px;
    border: none;
    border-radius: 5px;
    color: white;
    cursor: pointer;
    background-color: rgba(155, 30, 30, 0.952);
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.5);
    transition: background-color 0.5s ease;
}
.customer-user-billing-account-mpesa-top-up-entry-stk-push-button-container button:hover{
    background-color: rgba(196, 37, 37, 0.952);
}
.customer-user-billing-account-mpesa-topping-up-container{
    margin: 5vh 0;
    margin-bottom: 10vh;
    text-align: center;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.customer-user-billing-account-mpesa-topping-up-container .spinner{
    width: 40px;
    height: 40px;
    margin: auto;
    margin-bottom: 10px;
    border: 5px solid rgba(155, 30, 30, 0.952);
    border-top: 5px solid transparent;
    border-radius: 50%;
    animation: customer-user-billing-account-mpesa-topping-up-spinner 1s linear infinite;
}
@keyframes customer-user-billing-account-mpesa-topping-up-spinner {
    0% {transform: rotate(0deg);}
    100% {transform: rotate(360deg);}
}
.customer-user-billing-account-mpesa-topping-up-container p{
    padding: 10px;
    padding-left: 24px;
    margin: 25px 8vw;
    font-size: 15px;
    cursor: default;
    line-height: 1.4;
    border-radius: 10px;
    color: rgb(51, 51, 51);
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
}
.customer-user-billing-account-mpesa-top-up-success-container,
.customer-user-billing-account-mpesa-top-up-failed-container,
.customer-user-billing-account-mpesa-top-up-pending-container{
    margin: 50px;
}
.customer-user-billing-account-mpesa-top-up-success-container .header-paragraph,
.customer-user-billing-account-mpesa-top-up-failed-container .header-paragraph,
.customer-user-billing-account-mpesa-top-up-pending-container .header-paragraph{
    font-weight: 500;
    color: rgb(155, 30, 30);
}
.customer-user-billing-account-mpesa-top-up-success-container p,
.customer-user-billing-account-mpesa-top-up-failed-container p,
.customer-user-billing-account-mpesa-top-up-pending-container p{
    margin: 20px 0px;
}
.customer-user-billing-account-mpesa-top-up-success-container button,
.customer-user-billing-account-mpesa-top-up-failed-container button,
.customer-user-billing-account-mpesa-top-up-pending-container button{
    margin-right: 25px;
    padding: 10px 16px;
    border: none;
    border-radius: 5px;
    color: white;
    cursor: pointer;
    background-color: rgba(155, 30, 30, 0.952);
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.5);
    transition: background-color 0.5s ease;
}
.customer-user-billing-account-mpesa-top-up-success-container button:hover,
.customer-user-billing-account-mpesa-top-up-failed-container button:hover,
.customer-user-billing-account-mpesa-top-up-pending-container button:hover{
    background-color: rgba(196, 37, 37, 0.952);
}
.customer-user-billing-account-mpesa-top-up-failed-container .failure-body-container,
.customer-user-billing-account-mpesa-top-up-pending-container .pending-body-container{
    display: inline-block;
    padding: 10px 15px;
    margin-top: 10px;
    margin-bottom: 35px;
    border-radius: 10px;
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
}
.customer-user-billing-account-mpesa-top-up-failed-container .failure-body-container p,
.customer-user-billing-account-mpesa-top-up-pending-container .pending-body-container p{
    margin: 4px 0px;
    font-size: 14px;
    color: rgb(51, 51, 51);
}
/**BANK CHEQUE TOP UP**/
.customer-user-billing-account-bank-cheque-top-up-entry-container-parent{
    padding-bottom: 2vh;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.customer-user-billing-account-bank-cheque-top-up-entry-p{
    margin-left: 4vw;
    font-weight: 600;
    margin-bottom: 15px;
}
.customer-user-billing-account-bank-cheque-top-up-entry-container{
    height: auto;
    margin-left: 4vw;
    max-height: 35vh;
    overflow-y: auto;
}
.customer-user-billing-account-bank-cheque-top-up-entry-container::-webkit-scrollbar{
    width: 8px;
}
.customer-user-billing-account-bank-cheque-top-up-entry-container::-webkit-scrollbar-track{
    border-radius: 10px;
    background-color: rgb(201, 201, 201);
}
.customer-user-billing-account-bank-cheque-top-up-entry-container::-webkit-scrollbar-thumb{
    border-radius: 10px;
    background-color: gray;
}
.customer-user-billing-account-bank-cheque-top-up-entry-container-body{
    width: 50%;
}
.customer-user-billing-account-bank-cheque-top-up-entry-bank-name-container,
.customer-user-billing-account-bank-cheque-top-up-entry-cheque-number-container,
.customer-user-billing-account-bank-cheque-top-up-entry-bank-code-container,
.customer-user-billing-account-bank-cheque-top-up-entry-account-number-container,
.customer-user-billing-account-bank-cheque-top-up-entry-amount-container,
.customer-user-billing-account-bank-cheque-top-up-entry-currency-container{
    display: grid;
    grid-template-columns: 0.6fr 1fr;
    margin: 20px 0px;
}
.customer-user-billing-account-bank-cheque-top-up-entry-bank-name-container p,
.customer-user-billing-account-bank-cheque-top-up-entry-cheque-number-container p,
.customer-user-billing-account-bank-cheque-top-up-entry-bank-code-container p,
.customer-user-billing-account-bank-cheque-top-up-entry-account-number-container p,
.customer-user-billing-account-bank-cheque-top-up-entry-amount-container p,
.customer-user-billing-account-bank-cheque-top-up-entry-currency-container p{
    margin: 0px;
}
.customer-user-billing-account-bank-cheque-top-up-entry-bank-name-container input,
.customer-user-billing-account-bank-cheque-top-up-entry-cheque-number-container input,
.customer-user-billing-account-bank-cheque-top-up-entry-bank-code-container input,
.customer-user-billing-account-bank-cheque-top-up-entry-account-number-container input,
.customer-user-billing-account-bank-cheque-top-up-entry-amount-container input,
.customer-user-billing-account-bank-cheque-top-up-entry-currency-container input{
    border: none;
    outline: none;
    padding: 10px 15px;
    border-radius: 4px;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.35);
}
.customer-user-billing-account-bank-cheque-top-up-entry-currency-container select{
    width: 98%;
    margin: 0px;
    padding: 10px;
    outline: none;
    border: none;
    border-radius: 4px;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.35);
}
.customer-user-billing-account-bank-cheque-top-up-entry-deposit-button-container{
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
}
.customer-user-billing-account-bank-cheque-top-up-entry-deposit-button-container button{
    margin: 0px;
    padding: 8px 12px;
    border: none;
    border-radius: 5px;
    color: white;
    cursor: pointer;
    background-color: rgba(155, 30, 30, 0.952);
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.5);
    transition: background-color 0.5s ease;
}
.customer-user-billing-account-bank-cheque-top-up-entry-deposit-button-container button:hover{
    background-color: rgba(196, 37, 37, 0.952);
}
.customer-user-billing-account-bank-cheque-topping-up-container{
    margin-top: 5vh;
    margin-bottom: 8vh;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.customer-user-billing-account-bank-cheque-topping-up-container div{
    text-align: center;
}
.customer-user-billing-account-bank-cheque-topping-up-container div .spinner{
    width: 40px;
    height: 40px;
    margin: auto;
    margin-bottom: 10px;
    border: 5px solid rgba(155, 30, 30, 0.952);
    border-top: 5px solid transparent;
    border-radius: 50%;
    animation: customer-user-billing-account-bank-cheque-topping-up-spin 1s linear infinite;
}
@keyframes customer-user-billing-account-bank-cheque-topping-up-spin {
    0%{transform: rotate(0deg);}
    100%{transform: rotate(360deg);}
}
.customer-user-billing-account-bank-cheque-top-up-success-container,
.customer-user-billing-account-bank-cheque-top-up-failed-container{
    margin: 40px 20px;
}
.customer-user-billing-account-bank-cheque-top-up-success-container .header-paragraph,
.customer-user-billing-account-bank-cheque-top-up-failed-container .header-paragraph{
    font-weight: 500;
    color: rgb(155, 30, 30);
}
.customer-user-billing-account-bank-cheque-top-up-success-container p,
.customer-user-billing-account-bank-cheque-top-up-failed-container p{
    margin: 20px 0px;
}
.customer-user-billing-account-bank-cheque-top-up-success-container button{
    margin-right: 25px;
    padding: 10px 16px;
    border: none;
    border-radius: 5px;
    color: white;
    cursor: pointer;
    background-color: rgba(155, 30, 30, 0.952);
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.5);
    transition: background-color 0.5s ease;
}
.customer-user-billing-account-bank-cheque-top-up-failed-container button{
    margin-right: 25px;
    padding: 8px 18px;
    border: none;
    border-radius: 5px;
    color: white;
    cursor: pointer;
    background-color: rgba(155, 30, 30, 0.952);
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.5);
    transition: background-color 0.5s ease;
}
.customer-user-billing-account-bank-cheque-top-up-success-container button:hover,
.customer-user-billing-account-bank-cheque-top-up-failed-container button:hover{
    background-color: rgba(196, 37, 37, 0.952);
}`, "",{"version":3,"sources":["webpack://./src/styles/workspace_styles/TenantAdministratorStyles/Customers/CustomerUsers/CustomerUser.css"],"names":[],"mappings":"AAAA;IACI;QACI,sCAAsC;QACtC,uBAAuB;QACvB,kBAAkB;QAClB,QAAQ;QACR,UAAU;QACV,WAAW;QACX,UAAU;QACV,sBAAsB;QACtB,8BAA8B;IAClC;IACA;QACI,YAAY;QACZ,0CAA0C;QAC1C,aAAa;QACb,8BAA8B;QAC9B,aAAa;QACb,8BAA8B;IAClC;IACA;QACI,WAAW;QACX,oBAAoB;IACxB;IACA;QACI,WAAW;QACX,kBAAkB;QAClB,oBAAoB;QACpB,eAAe;QACf,eAAe;IACnB;IACA;QACI,WAAW;QACX,oBAAoB;QACpB,eAAe;IACnB;IACA;QACI,kBAAkB;QAClB,2CAA2C;IAC/C;IACA;QACI,kBAAkB;QAClB,YAAY;QACZ,aAAa;QACb,eAAe;QACf,iBAAiB;QACjB,iBAAiB;QACjB,mBAAmB;QACnB,6BAA6B;QAC7B,0CAA0C;IAC9C;IACA;QACI,kBAAkB;QAClB,aAAa;IACjB;IACA;QACI,kBAAkB;QAClB,iBAAiB;QACjB,YAAY;QACZ,kBAAkB;QAClB,YAAY;QACZ,eAAe;QACf,0CAA0C;QAC1C,0CAA0C;QAC1C,sCAAsC;IAC1C;IACA;QACI,0CAA0C;IAC9C;IACA;QACI,kBAAkB;QAClB,SAAS;QACT,kBAAkB;QAClB,0CAA0C;IAC9C;IACA;QACI,kBAAkB;QAClB,SAAS;QACT,kBAAkB;QAClB,mBAAmB;QACnB,YAAY;QACZ,8CAA8C;QAC9C,oCAAoC;IACxC;IACA;QACI,WAAW;QACX,kBAAkB;IACtB;IACA;QACI,YAAY;QACZ,kBAAkB;IACtB;IACA;QACI,WAAW;QACX,iBAAiB;IACrB;IACA;QACI,YAAY;IAChB;AACJ;AACA;IACI;QACI,sCAAsC;QACtC,uBAAuB;QACvB,kBAAkB;QAClB,QAAQ;QACR,UAAU;QACV,YAAY;QACZ,WAAW;QACX,sBAAsB;QACtB,mBAAmB;IACvB;IACA;QACI,YAAY;QACZ,0CAA0C;QAC1C,aAAa;QACb,gCAAgC;QAChC,aAAa;QACb,8BAA8B;IAClC;IACA;QACI,WAAW;QACX,eAAe;QACf,oBAAoB;IACxB;IACA;QACI,WAAW;QACX,eAAe;QACf,eAAe;QACf,gBAAgB;QAChB,kBAAkB;QAClB,sBAAsB;QACtB,oBAAoB;IACxB;IACA;QACI,WAAW;QACX,oBAAoB;QACpB,eAAe;IACnB;IACA;QACI,aAAa;QACb,WAAW;QACX,aAAa;QACb,cAAc;QACd,mBAAmB;QACnB,sBAAsB;QACtB,uBAAuB;QACvB,0CAA0C;IAC9C;IACA;QACI,kBAAkB;QAClB,iBAAiB;QACjB,YAAY;QACZ,kBAAkB;QAClB,YAAY;QACZ,eAAe;QACf,mBAAmB;QACnB,0CAA0C;QAC1C,0CAA0C;QAC1C,sCAAsC;IAC1C;IACA;QACI,0CAA0C;IAC9C;IACA;QACI,uBAAuB;IAC3B;AACJ;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,oCAAoC;AACxC;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,yCAAyC;IACzC,6BAA6B;IAC7B,8BAA8B;AAClC;AACA;IACI,yCAAyC;IACzC,oCAAoC;AACxC;AACA;IACI,WAAW;IACX,eAAe;IACf,eAAe;IACf,6BAA6B;AACjC;AACA;IACI,UAAU;AACd;AACA;IACI,WAAW;IACX,aAAa;IACb,YAAY;IACZ,WAAW;IACX,eAAe;IACf,6BAA6B;AACjC;AACA;IACI,YAAY;AAChB;AACA;IACI,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,eAAe;IACf,eAAe;AACnB;AACA;IACI,aAAa;AACjB;AACA;IACI,cAAc;IACd,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,OAAO;IACP,QAAQ;IACR,UAAU;IACV,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,0CAA0C;AAC9C;AACA;IACI,cAAc;AAClB;AACA;IACI,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,4DAA4D;IAC5D,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,6BAA6B;AACjC;AACA;IACI,aAAa;IACb,iBAAiB;IACjB,8BAA8B;AAClC;AACA;IACI,UAAU;AACd;AACA;IACI,WAAW;IACX,eAAe;IACf,eAAe;AACnB;AACA;IACI,WAAW;IACX,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,oCAAoC;IACpC,2CAA2C;AAC/C;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,eAAe;IACf,eAAe;IACf,yBAAyB;AAC7B;AACA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,0CAA0C;IAC1C,UAAU;IACV,4BAA4B;IAC5B,yFAAyF;AAC7F;AACA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,4DAA4D;IAC5D,sBAAsB;AAC1B;AACA;IACI,gBAAgB;IAChB,oBAAoB;AACxB;AACA;IACI,eAAe;IACf,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,yBAAyB;AAC7B;AACA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,0CAA0C;IAC1C,2CAA2C;IAC3C,0DAA0D;IAC1D,+BAA+B;AACnC;AACA;IACI,0CAA0C;IAC1C,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,yCAAyC;IACzC,UAAU;IACV,4BAA4B;IAC5B,wFAAwF;AAC5F;AACA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;AACA;IACI,WAAW;IACX,4DAA4D;AAChE;AACA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,0CAA0C;IAC1C,iCAAiC;IACjC,kBAAkB;IAClB,4EAA4E;AAChF;AACA;IACI,KAAK,uBAAuB,CAAC;IAC7B,GAAG,yBAAyB,CAAC;AACjC;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,yCAAyC;IACzC,UAAU;IACV,4BAA4B;IAC5B,uFAAuF;AAC3F;AACA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;AACA;IACI,eAAe;IACf,4DAA4D;AAChE;AACA;IACI,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,yBAAyB;AAC7B;AACA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,0CAA0C;IAC1C,2CAA2C;IAC3C,0DAA0D;IAC1D,+BAA+B;AACnC;AACA;IACI,sBAAsB;IACtB,0CAA0C;AAC9C;AACA;IACI,gBAAgB;IAChB,2CAA2C;AAC/C;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,0CAA0C;IAC1C,2CAA2C;IAC3C,sCAAsC;AAC1C;AACA;IACI,gCAAgC;AACpC;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,gCAAgC;AACpC;AACA;IACI,kBAAkB;AACtB;AACA;IACI,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,0CAA0C;IAC1C,4DAA4D;IAC5D,UAAU;IACV,4BAA4B;IAC5B,uFAAuF;AAC3F;AACA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;AACA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;;IAEI,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,uBAAuB;AAC3B;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;AACA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,aAAa;IACb,gCAAgC;AACpC;AACA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,0CAA0C;IAC1C,UAAU;IACV,0BAA0B;IAC1B,6BAA6B;IAC7B,sGAAsG;AAC1G;AACA;IACI;QACI,UAAU;QACV,0BAA0B;IAC9B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;AACA;IACI,WAAW;AACf;AACA,oBAAoB;AACpB;IACI,aAAa;IACb,gBAAgB;IAChB,sCAAsC;IACtC,4DAA4D;AAChE;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,0CAA0C;IAC1C,UAAU;IACV,0BAA0B;IAC1B,gGAAgG;AACpG;AACA;IACI;QACI,UAAU;QACV,0BAA0B;IAC9B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;AACA;;;;IAII,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,YAAY;AAChB;AACA;IACI,aAAa;AACjB;AACA;IACI,UAAU;AACd;AACA;IACI,eAAe;IACf,eAAe;IACf,eAAe;AACnB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,WAAW;IACX,eAAe;AACnB;AACA;;IAEI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,eAAe;AACnB;AACA;;IAEI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,UAAU;IACV,eAAe;AACnB;AACA;IACI,UAAU;AACd;AACA;IACI,eAAe;IACf,eAAe;IACf,eAAe;AACnB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,eAAe;AACnB;AACA;;IAEI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,eAAe;AACnB;AACA;;IAEI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,UAAU;IACV,eAAe;AACnB;AACA,uBAAuB;AACvB;IACI,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,0CAA0C;IAC1C,4DAA4D;AAChE;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,eAAe;AACnB;AACA;IACI,YAAY;AAChB;AACA;IACI,WAAW;IACX,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;IACI,uCAAuC;AAC3C;AACA;;IAEI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;IACI,2CAA2C;AAC/C;AACA;IACI,oCAAoC;AACxC;AACA,iBAAiB;AACjB;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,0CAA0C;IAC1C,UAAU;IACV,2BAA2B;IAC3B,+EAA+E;AACnF;AACA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;AACA;IACI,iBAAiB;IACjB,2CAA2C;AAC/C;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,0CAA0C;IAC1C,0CAA0C;IAC1C,sCAAsC;AAC1C;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;AACA,gBAAgB;AAChB;IACI,UAAU;IACV,gBAAgB;IAChB,4DAA4D;AAChE;AACA;IACI,gBAAgB;AACpB;AACA;;IAEI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;AACA;;IAEI,WAAW;AACf;AACA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,2CAA2C;AAC/C;AACA;IACI,UAAU;IACV,WAAW;IACX,aAAa;IACb,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,2CAA2C;AAC/C;AACA;IACI,aAAa;IACb,yBAAyB;AAC7B;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,0CAA0C;IAC1C,0CAA0C;IAC1C,sCAAsC;AAC1C;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,4DAA4D;AAChE;AACA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,0CAA0C;IAC1C,iCAAiC;IACjC,kBAAkB;IAClB,qFAAqF;AACzF;AACA;IACI,IAAI,uBAAuB,CAAC;IAC5B,MAAM,yBAAyB,CAAC;AACpC;AACA;;IAEI,gBAAgB;IAChB,gBAAgB;AACpB;AACA;;IAEI,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;;IAEI,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,0CAA0C;IAC1C,0CAA0C;IAC1C,sCAAsC;AAC1C;AACA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,0CAA0C;IAC1C,0CAA0C;IAC1C,sCAAsC;AAC1C;AACA;IACI,0CAA0C;AAC9C;AACA,iBAAiB;AACjB;IACI,UAAU;IACV,gBAAgB;IAChB,4DAA4D;AAChE;AACA;;IAEI,aAAa;IACb,gCAAgC;IAChC,mBAAmB;IACnB,mBAAmB;AACvB;AACA;;IAEI,WAAW;AACf;AACA;IACI,eAAe;IACf,UAAU;IACV,cAAc;IACd,eAAe;IACf,UAAU;IACV,iBAAiB;AACrB;AACA;;IAEI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,0CAA0C;AAC9C;AACA;IACI,aAAa;IACb,yBAAyB;IACzB,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,0CAA0C;IAC1C,0CAA0C;IAC1C,sCAAsC;AAC1C;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,4DAA4D;AAChE;AACA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,0CAA0C;IAC1C,iCAAiC;IACjC,kBAAkB;IAClB,oFAAoF;AACxF;AACA;IACI,IAAI,uBAAuB,CAAC;IAC5B,MAAM,yBAAyB,CAAC;AACpC;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,0CAA0C;AAC9C;AACA;;;IAGI,YAAY;AAChB;AACA;;;IAGI,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;;;IAGI,gBAAgB;AACpB;AACA;;;IAGI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,0CAA0C;IAC1C,0CAA0C;IAC1C,sCAAsC;AAC1C;AACA;;;IAGI,0CAA0C;AAC9C;AACA;;IAEI,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,0CAA0C;AAC9C;AACA;;IAEI,eAAe;IACf,eAAe;IACf,sBAAsB;AAC1B;AACA,uBAAuB;AACvB;IACI,mBAAmB;IACnB,4DAA4D;AAChE;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,UAAU;AACd;AACA;IACI,mBAAmB;IACnB,oCAAoC;AACxC;AACA;IACI,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,UAAU;AACd;AACA;;;;;;IAMI,aAAa;IACb,gCAAgC;IAChC,gBAAgB;AACpB;AACA;;;;;;IAMI,WAAW;AACf;AACA;;;;;;IAMI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,2CAA2C;AAC/C;AACA;IACI,UAAU;IACV,WAAW;IACX,aAAa;IACb,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,2CAA2C;AAC/C;AACA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,0CAA0C;IAC1C,0CAA0C;IAC1C,sCAAsC;AAC1C;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,4DAA4D;AAChE;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,0CAA0C;IAC1C,iCAAiC;IACjC,kBAAkB;IAClB,uFAAuF;AAC3F;AACA;IACI,GAAG,uBAAuB,CAAC;IAC3B,KAAK,yBAAyB,CAAC;AACnC;AACA;;IAEI,iBAAiB;AACrB;AACA;;IAEI,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;;IAEI,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,0CAA0C;IAC1C,0CAA0C;IAC1C,sCAAsC;AAC1C;AACA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,0CAA0C;IAC1C,0CAA0C;IAC1C,sCAAsC;AAC1C;AACA;;IAEI,0CAA0C;AAC9C","sourcesContent":["@media screen and (min-width:950px){\r\n    .customer-user-container{\r\n        box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);\r\n        background-color: white;\r\n        position: absolute;\r\n        top: 2vh;\r\n        right: 0px;\r\n        height: 95%;\r\n        width: 70%;\r\n        box-sizing: border-box;\r\n        border-radius: 5px 0px 0px 5px;\r\n    }\r\n    .customer-user-container-header{\r\n        color: white;\r\n        background-color: rgba(155, 30, 30, 0.952);\r\n        padding: 15px;\r\n        border-radius: 5px 0px 0px 0px;\r\n        display: flex;\r\n        justify-content: space-between;\r\n    }\r\n    .customer-user-container-header h3{\r\n        margin: 0px;\r\n        font-weight: lighter;\r\n    }\r\n    .customer-user-container-header p{\r\n        margin: 0px;\r\n        margin-right: 20px;\r\n        font-weight: lighter;\r\n        font-size: 30px;\r\n        cursor: pointer;\r\n    }\r\n    .customer-user-container-header h4{\r\n        margin: 0px;\r\n        font-weight: lighter;\r\n        font-size: 14px;\r\n    }\r\n    .customer-user-container-navigation-bar{\r\n        padding: 10px 20px;\r\n        border-bottom: 1px solid rgb(211, 210, 210);\r\n    }\r\n    .customer-user-container-navigation-bar button{\r\n        margin-right: 20px;\r\n        border: none;\r\n        outline: none;\r\n        cursor: pointer;\r\n        text-wrap: nowrap;\r\n        padding: 8px 16px;\r\n        border-radius: 80px;\r\n        background-color: transparent;\r\n        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);\r\n    }\r\n    .customer-user-details-container-navigation-bar{\r\n        position: relative;\r\n        padding: 20px;\r\n    }\r\n    .customer-user-details-container-navigation-bar button{\r\n        margin-right: 20px;\r\n        padding: 8px 12px;\r\n        border: none;\r\n        border-radius: 5px;\r\n        color: white;\r\n        cursor: pointer;\r\n        background-color: rgba(155, 30, 30, 0.952);\r\n        box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.5);\r\n        transition: background-color 0.5s ease;\r\n    }\r\n    .customer-user-details-container-navigation-bar button:hover{\r\n        background-color: rgba(187, 35, 35, 0.952);\r\n    }\r\n    #edit-icon,#discard-changes-icon,#save-changes-icon.active{\r\n        position: absolute;\r\n        top: 10px;\r\n        border-radius: 50%;\r\n        background-color: rgba(233, 77, 30, 0.952);\r\n    }\r\n    #save-changes-icon.inactive{\r\n        position: absolute;\r\n        top: 10px;\r\n        border-radius: 50%;\r\n        cursor: not-allowed;\r\n        opacity: 0.7;\r\n        box-shadow: 0px 0px 2px rgba(255, 255, 255, 0);\r\n        background-color: rgb(219, 219, 219);\r\n    }\r\n    #discard-changes-icon{\r\n        right: 40px;\r\n        padding: 10px 14px;\r\n    }\r\n    #save-changes-icon{\r\n        right: 100px;\r\n        padding: 11px 15px;\r\n    }\r\n    #edit-icon{\r\n        right: 40px;\r\n        padding: 8px 10px;\r\n    }\r\n    #edit-icon img{\r\n        height: 20px;\r\n    }\r\n}\r\n@media screen and (max-width:949px){\r\n    .customer-user-container{\r\n        box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);\r\n        background-color: white;\r\n        position: absolute;\r\n        top: 0vh;\r\n        right: 0px;\r\n        height: 100%;\r\n        width: 100%;\r\n        box-sizing: border-box;\r\n        border-radius: 10px;\r\n    }\r\n    .customer-user-container-header{\r\n        color: white;\r\n        background-color: rgba(155, 30, 30, 0.952);\r\n        padding: 15px;\r\n        border-radius: 10px 10px 0px 0px;\r\n        display: flex;\r\n        justify-content: space-between;\r\n    }\r\n    .customer-user-container-header h3{\r\n        margin: 0px;\r\n        font-size: 16px;\r\n        font-weight: lighter;\r\n    }\r\n    .customer-user-container-header p{\r\n        margin: 0px;\r\n        cursor: pointer;\r\n        font-size: 20px;\r\n        margin-top: -6px;\r\n        margin-right: 10px;\r\n        box-sizing: border-box;\r\n        font-weight: lighter;\r\n    }\r\n    .customer-user-container-header h4{\r\n        margin: 0px;\r\n        font-weight: lighter;\r\n        font-size: 13px;\r\n    }\r\n    .customer-user-details-container-navigation-bar{\r\n        padding: 20px;\r\n        width: 100%;\r\n        display: flex;\r\n        overflow: auto;\r\n        align-items: center;\r\n        box-sizing: border-box;\r\n        padding: 20px!important;\r\n        box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.2);\r\n    }\r\n    .customer-user-details-container-navigation-bar button{\r\n        margin-right: 20px;\r\n        padding: 8px 12px;\r\n        border: none;\r\n        border-radius: 5px;\r\n        color: white;\r\n        cursor: pointer;\r\n        white-space: nowrap;\r\n        background-color: rgba(155, 30, 30, 0.952);\r\n        box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.5);\r\n        transition: background-color 0.5s ease;\r\n    }\r\n    .customer-user-details-container-navigation-bar button:hover{\r\n        background-color: rgba(187, 35, 35, 0.952);\r\n    }\r\n    #edit-icon,#discard-changes-icon,#save-changes-icon{\r\n        display: none!important;\r\n    }\r\n}\r\n.customer-user-details-container-body{\r\n    max-height: 55vh;\r\n    overflow: auto;\r\n    padding: 0px 20px;\r\n}\r\n.customer-user-details-container-body::-webkit-scrollbar{\r\n    width: 5px;\r\n}\r\n.customer-user-details-container-body::-webkit-scrollbar-thumb{\r\n    border-radius: 5px;\r\n    background-color: rgba(0, 0, 0, 0.2);\r\n}\r\n.customer-user-details-container-body-component{\r\n    margin: 20px;\r\n    padding: 5px 10px;\r\n    position: relative;\r\n    background-color: rgba(222, 229, 233,0.6);\r\n    border-bottom: 1px solid gray;\r\n    border-radius: 2px 2px 0px 0px;\r\n}\r\n.customer-user-details-container-body-component.edit:focus-within{\r\n    border-bottom: 2px solid rgb(119, 12, 12);\r\n    background-color: rgb(221, 232, 238);\r\n}\r\n.customer-user-details-container-body-component p{\r\n    margin: 0px;\r\n    font-size: 10px;\r\n    cursor: default;\r\n    background-color: transparent;\r\n}\r\n.customer-user-details-container-body-component span{\r\n    color: red;\r\n}\r\n.customer-user-details-container-body-component input{\r\n    margin: 0px;\r\n    outline: none;\r\n    border: none;\r\n    width: 100%;\r\n    cursor: default;\r\n    background-color: transparent;\r\n}\r\n.customer-user-details-container-body-component.edit input{\r\n    cursor: text;\r\n}\r\n.customer-user-details-container-body-component-country-display{\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n.customer-user-details-container-body-component-country-display p{\r\n    font-size: 14px;\r\n    margin: 2px 0px;\r\n}\r\n.customer-user-details-container-body-component-country-display .cancel-p{\r\n    display: none;\r\n}\r\n.customer-user-details-container-body-component-country-display.edit .cancel-p{\r\n    display: block;\r\n    cursor: pointer;\r\n    color: rgb(54, 54, 54);\r\n}\r\n.customer-user-details-container-body-component-countries-browser{\r\n    position: absolute;\r\n    top: calc(100% + 2px);\r\n    left: 0;\r\n    right: 0;\r\n    z-index: 1;\r\n    display: none;\r\n    overflow: auto;\r\n    max-height: 17vh;\r\n    background-color: white;\r\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);\r\n}\r\n.customer-user-details-container-body-component-countries-browser.active{\r\n    display: block;\r\n}\r\n.customer-user-details-container-body-component-countries-browser::-webkit-scrollbar{\r\n    width: 4px;\r\n}\r\n.customer-user-details-container-body-component-countries-browser::-webkit-scrollbar-thumb{\r\n    border-radius: 5px;\r\n    background-color: gray;\r\n}\r\n.customer-user-details-container-body-component-countries-browser div{\r\n    padding: 5px 16px;\r\n    font-size: 14px;\r\n    cursor: pointer;\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n    border: 1px solid rgb(250, 250, 250);\r\n}\r\n.customer-user-details-container-body-component-countries-browser div:hover{\r\n    background-color: rgb(221, 232, 238);\r\n}\r\n.customer-user-details-container-body-component select{\r\n    margin: 0px;\r\n    width: 100%;\r\n    border: none;\r\n    outline: none;\r\n    padding: 2px 0px;\r\n    background-color: transparent;\r\n}\r\n.customer-user-details-dashboard-settings-container{\r\n    display: grid;\r\n    padding: 0px 20px;\r\n    grid-template-columns: 1fr 1fr;\r\n}\r\n.customer-user-details-default-dashboard-selection-container{\r\n    width: 80%;\r\n}\r\n.customer-user-details-default-dashboard-selection-container p{\r\n    margin: 0px;\r\n    font-size: 12px;\r\n    cursor: default;\r\n}\r\n.customer-user-details-default-dashboard-selection-container select{\r\n    width: 100%;\r\n    margin: 0px;\r\n    margin-top: 5px;\r\n    padding: 6px 12px;\r\n    border: none;\r\n    outline: none;\r\n    border-radius: 2px;\r\n    background-color: rgb(222, 229, 233);\r\n    border-bottom: 1px solid rgb(163, 163, 163);\r\n}\r\n.customer-user-details-default-dashboard-show-full-screen-container{\r\n    display: flex;\r\n    align-items: center;\r\n    padding-top: 10px;\r\n}\r\n.customer-user-details-default-dashboard-show-full-screen-container p{\r\n    margin: 0px;\r\n    font-size: 14px;\r\n    cursor: default;\r\n    color: rgb(100, 100, 100);\r\n}\r\n.customer-user-details-default-dashboard-show-full-screen-container img{\r\n    height: 20px;\r\n    margin: 15px 30px;\r\n}\r\n\r\n.customer-user-billing-account-missing-container-wrapper{\r\n    margin-top: 6vh;\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n.customer-user-billing-account-missing-container{\r\n    padding: 15px 25px;\r\n    border-radius: 10px;\r\n    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.2);\r\n    opacity: 0;\r\n    transform: translateY(-20px);\r\n    animation: customer-user-billing-account-missing-container-fade-in 0.8s ease-out forwards;\r\n}\r\n@keyframes customer-user-billing-account-missing-container-fade-in {\r\n    from {\r\n        opacity: 0;\r\n        transform: translateY(-20px);\r\n    }\r\n    to{\r\n        opacity: 1;\r\n        transform: translateY(0);\r\n    }\r\n}\r\n.customer-user-billing-account-missing-header-container p{\r\n    margin: 2px 0px;\r\n    font-weight: 600;\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n    color: rgb(70, 70, 70);\r\n}\r\n.customer-user-billing-account-missing-body-container{\r\n    padding: 8px 0px;\r\n    padding-bottom: 20px;\r\n}\r\n.customer-user-billing-account-missing-body-container p{\r\n    margin: 2px 0px;\r\n    font-size: 14px;\r\n    color: rgb(51, 51, 51);\r\n}\r\n.customer-user-billing-account-missing-button-container{\r\n    display: flex;\r\n    justify-content: flex-end;\r\n}\r\n.customer-user-billing-account-missing-button-container button{\r\n    padding: 8px 12px;\r\n    border: none;\r\n    border-radius: 5px;\r\n    color: white;\r\n    cursor: pointer;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);\r\n    transition: background-color 0.5s ease,transform 0.2s ease;\r\n    transform-origin: center center;\r\n}\r\n.customer-user-billing-account-missing-button-container button:hover{\r\n    background-color: rgba(196, 37, 37, 0.952);\r\n    transform: scale(1.10);\r\n}\r\n\r\n.customer-user-billing-account-creating-container{\r\n    margin-top: 5vh;\r\n    padding: 15px 35px;\r\n    border-radius: 10px;\r\n    box-shadow: 0px 2px 8px rgba(0, 0, 0,0.2);\r\n    opacity: 0;\r\n    transform: translateY(-20px);\r\n    animation: customer-user-billing-account-creating-container-fade-in 0.8s linear forwards;\r\n}\r\n@keyframes customer-user-billing-account-creating-container-fade-in {\r\n    from{\r\n        opacity: 0;\r\n        transform: translateY(-20px);\r\n    }\r\n    to{\r\n        opacity: 1;\r\n        transform: translateY(0);\r\n    }\r\n}\r\n.customer-user-billing-account-creating-container p{\r\n    margin: 0px;\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n.customer-user-billing-account-creating-body{\r\n    margin-top: 15px;\r\n    margin-bottom: 5px;\r\n}\r\n.customer-user-billing-account-creating-body span{\r\n    margin-left: 2px;\r\n    color: rgb(77, 77, 77);\r\n}\r\n.customer-user-billing-account-creating-spinner-container{\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n.customer-user-billing-account-creating-spinner-container div{\r\n    width: 40px;\r\n    height: 40px;\r\n    box-sizing: border-box;\r\n    border: 5px solid rgba(155, 30, 30, 0.952);\r\n    border-top: 5px solid transparent;\r\n    border-radius: 50%;\r\n    animation: customer-user-billing-account-creating-spinner 1s linear infinite;\r\n}\r\n@keyframes customer-user-billing-account-creating-spinner {\r\n    from{transform: rotate(0deg);}\r\n    to{transform: rotate(360deg);}\r\n}\r\n.customer-user-billing-account-created-container{\r\n    margin-top: 5vh;\r\n    padding: 15px 35px;\r\n    border-radius: 10px;\r\n    box-shadow: 0px 2px 8px rgba(0, 0, 0,0.2);\r\n    opacity: 0;\r\n    transform: translateY(-20px);\r\n    animation: customer-user-billing-account-created-container-fade-in 0.8s linear forwards;\r\n}\r\n@keyframes customer-user-billing-account-created-container-fade-in{\r\n    from{\r\n        opacity: 0;\r\n        transform: translateY(-20px);\r\n    }\r\n    to{\r\n        opacity: 1;\r\n        transform: translateY(0);\r\n    }\r\n}\r\n.customer-user-billing-account-created-container p{\r\n    margin: 4px 0px;\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n.customer-user-billing-account-created-container .title-paragraph{\r\n    font-weight: 600;\r\n    color: rgb(70, 70, 70);\r\n}\r\n.customer-user-billing-account-created-container .message-paragraph{\r\n    font-weight: 400;\r\n    color: rgb(51, 51, 51);\r\n}\r\n.customer-user-billing-account-created-container div{\r\n    margin-top: 15px;\r\n    display: flex;\r\n    justify-content: flex-end;\r\n}\r\n.customer-user-billing-account-created-container div button{\r\n    padding: 8px 16px;\r\n    border: none;\r\n    border-radius: 5px;\r\n    color: white;\r\n    cursor: pointer;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);\r\n    transition: background-color 0.5s ease,transform 0.2s ease;\r\n    transform-origin: center center;\r\n}\r\n.customer-user-billing-account-created-container div button:hover{\r\n    transform: scale(1.10);\r\n    background-color: rgba(196, 37, 37, 0.952);\r\n}\r\n.customer-user-billing-account-management-navigation-bar{\r\n    padding: 8px 5px;\r\n    border-bottom: 1px solid rgb(168, 168, 168);\r\n}\r\n.customer-user-billing-account-management-navigation-bar button{\r\n    margin: 0px 12px;\r\n    padding: 8px 12px;\r\n    border: none;\r\n    border-radius: 5px;\r\n    color: white;\r\n    cursor: pointer;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.2);\r\n    transition: background-color 0.5s ease;\r\n}\r\n.customer-user-billing-account-management-navigation-bar button.active{\r\n    background-color: rgb(0, 125, 0);\r\n}\r\n.customer-user-billing-account-management-navigation-bar button:hover{\r\n    background-color: rgba(196, 37, 37, 0.952);\r\n}\r\n.customer-user-billing-account-management-navigation-bar button.active:hover{\r\n    background-color: rgb(0, 165, 0);\r\n}\r\n.customer-user-billing-account-summary-container{\r\n    padding: 10px 20px;\r\n}\r\n.customer-user-billing-account-details-parent-container{\r\n    display: flex;\r\n}\r\n.customer-user-billing-account-details-container{\r\n    padding: 15px 25px;\r\n    border-radius: 4px;\r\n    margin-right: 10px;\r\n    display: inline-block;\r\n    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.2);\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n    opacity: 0;\r\n    transform: translateX(-20px);\r\n    animation: customer-user-billing-account-details-container-fade-in 0.8s linear forwards;\r\n}\r\n@keyframes customer-user-billing-account-details-container-fade-in{\r\n    from{\r\n        opacity: 0;\r\n        transform: translateX(-20px);\r\n    }\r\n    to{\r\n        opacity: 1;\r\n        transform: translateX(0);\r\n    }\r\n}\r\n.customer-user-billing-account-details-container.account-no{\r\n    padding-left: 38px;\r\n    padding-right: 38px;\r\n}\r\n.customer-user-billing-account-account-number-header,\r\n.customer-user-billing-account-balance-header{\r\n    margin: 0px;\r\n    font-weight: 600;\r\n}\r\n.customer-user-billing-account-account-number-paragraph{\r\n    margin: 10px 0px;\r\n    font-weight: 600;\r\n    font-size: 26px;\r\n    color: rgb(212, 145, 0);\r\n}\r\n.customer-user-billing-account-delete-account-paragraph{\r\n    text-align: right;\r\n    font-size: 16px;\r\n    cursor: pointer;\r\n    font-weight: 500;\r\n    color: rgb(194, 0, 0);\r\n}\r\n.customer-user-billing-account-balance-paragraph{\r\n    margin: 10px 0px;\r\n    color: rgb(161, 161, 161);\r\n    font-weight: 600;\r\n    font-size: 26px;\r\n}\r\n.customer-user-billing-account-date-time-created-container{\r\n    display: grid;\r\n    grid-template-columns: 1.5fr 1fr;\r\n}\r\n.customer-user-billing-account-date-time-created-container p{\r\n    margin: 4px 0px;\r\n}\r\n.customer-user-billing-account-summary-no-transactions-container{\r\n    margin-top: 15px;\r\n    padding: 25px 20px;\r\n    border-radius: 10px;\r\n    display: inline-block;\r\n    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.2);\r\n    opacity: 0;\r\n    transform: translateX(5vw);\r\n    transition: opacity 0.8s ease;\r\n    animation: customer-user-billing-account-summary-no-transaction-container-fade-in 0.8s linear forwards;\r\n}\r\n@keyframes customer-user-billing-account-summary-no-transaction-container-fade-in{\r\n    from{\r\n        opacity: 0;\r\n        transform: translateX(5vw);\r\n    }\r\n    to{\r\n        opacity: 1;\r\n        transform: translateX(0);\r\n    }\r\n}\r\n.customer-user-billing-account-summary-no-transactions-container p{\r\n    margin: 0px;\r\n}\r\n/*Transaction cards*/\r\n.customer-user-billing-account-summary-transaction-cards-container{\r\n    display: grid;\r\n    column-gap: 15px;\r\n    grid-template-columns: 1fr 1fr 1fr 1fr;\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n.customer-user-billing-account-summary-transaction-cards-container .transaction-card{\r\n    padding: 10px;\r\n    border-radius: 4px;\r\n    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.2);\r\n    opacity: 0;\r\n    transform: translateY(4vh);\r\n    animation: customer-user-billing-account-summary-transaction-card-fade-in 0.8s ease-out forwards;\r\n}\r\n@keyframes customer-user-billing-account-summary-transaction-card-fade-in{\r\n    from{\r\n        opacity: 0;\r\n        transform: translateY(4vh);\r\n    }\r\n    to{\r\n        opacity: 1;\r\n        transform: translateY(0);\r\n    }\r\n}\r\n.customer-user-billing-account-summary-transaction-cards-container .transaction-card-top-up-p,\r\n.customer-user-billing-account-summary-transaction-cards-container .transaction-card-top-up-pending-p,\r\n.customer-user-billing-account-summary-transaction-cards-container .transaction-card-top-up-failed-p,\r\n.customer-user-billing-account-summary-transaction-cards-container .transaction-card-deduction-p{\r\n    margin: 2px 0px;\r\n    font-size: 15px;\r\n    font-weight: 600;\r\n    cursor: default;\r\n}\r\n.customer-user-billing-account-summary-transaction-cards-container .transaction-card-top-up-p{\r\n    color: green;\r\n}\r\n.customer-user-billing-account-summary-transaction-cards-container .transaction-card-top-up-pending-p{\r\n    color: orange;\r\n}\r\n.customer-user-billing-account-summary-transaction-cards-container .transaction-card-top-up-failed-p{\r\n    color: red;\r\n}\r\n.customer-user-billing-account-summary-transaction-cards-container .transaction-card-top-up-type-p{\r\n    margin: 4px 0px;\r\n    font-size: 15px;\r\n    cursor: default;\r\n}\r\n.customer-user-billing-account-summary-transaction-cards-container .transaction-card-top-up-amount-container{\r\n    margin: 0px;\r\n    margin-bottom: 5px;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n}\r\n.customer-user-billing-account-summary-transaction-cards-container .transaction-card-top-up-amount-container p{\r\n    margin: 0px;\r\n    cursor: default;\r\n}\r\n.customer-user-billing-account-summary-transaction-cards-container .transaction-card-top-up-date-container,\r\n.customer-user-billing-account-summary-transaction-cards-container .transaction-card-top-up-time-container{\r\n    margin: 0px;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    cursor: default;\r\n}\r\n.customer-user-billing-account-summary-transaction-cards-container .transaction-card-top-up-date-container p,\r\n.customer-user-billing-account-summary-transaction-cards-container .transaction-card-top-up-time-container p{\r\n    margin: 0px;\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    color: rgb(66, 66, 66);\r\n}\r\n.customer-user-billing-account-summary-transaction-cards-container .transaction-card-top-up-image-container{\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n.customer-user-billing-account-summary-transaction-cards-container .transaction-card-top-up-image-container img{\r\n    width: 4vw;\r\n    margin: 4vh 0px;\r\n}\r\n.customer-user-billing-account-summary-transaction-cards-container .transaction-card-deduction-p{\r\n    color: red;\r\n}\r\n.customer-user-billing-account-summary-transaction-cards-container .transaction-card-deduction-desc-p{\r\n    margin: 4px 0px;\r\n    font-size: 15px;\r\n    cursor: default;\r\n}\r\n.customer-user-billing-account-summary-transaction-cards-container .transaction-card-deduction-amount-container{\r\n    margin: 0px;\r\n    margin-bottom: 5px;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n}\r\n.customer-user-billing-account-summary-transaction-cards-container .transaction-card-deduction-amount-container p{\r\n    margin: 2px 0px;\r\n}\r\n.customer-user-billing-account-summary-transaction-cards-container .transaction-card-deduction-date-container,\r\n.customer-user-billing-account-summary-transaction-cards-container .transaction-card-deduction-time-container{\r\n    margin: 0px;\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    cursor: default;\r\n}\r\n.customer-user-billing-account-summary-transaction-cards-container .transaction-card-deduction-date-container p,\r\n.customer-user-billing-account-summary-transaction-cards-container .transaction-card-deduction-time-container p{\r\n    margin: 0px;\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    color: rgb(66, 66, 66);\r\n}\r\n.customer-user-billing-account-summary-transaction-cards-container .transaction-card-deduction-image-container{\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n.customer-user-billing-account-summary-transaction-cards-container .transaction-card-deduction-image-container img{\r\n    width: 4vw;\r\n    margin: 4vh 0px;\r\n}\r\n/*TRANSACTIONS SECTION*/\r\n.customer-user-billing-account-transactions-table-container{\r\n    margin: 4vh 4vw;\r\n    position: relative;\r\n    border-radius: 5px;\r\n    max-height: 50vh;\r\n    overflow-y: scroll;\r\n    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n.customer-user-billing-account-transactions-sort-container{\r\n    position: absolute;\r\n    top: 4px;\r\n    right: 20px;\r\n    cursor: pointer;\r\n}\r\n.customer-user-billing-account-transactions-sort-container img{\r\n    height: 20px;\r\n}\r\n.customer-user-billing-account-transactions-table-container table{\r\n    width: 100%;\r\n    table-layout: fixed;\r\n    border-collapse: collapse;\r\n}\r\n.customer-user-billing-account-transaction-table-header-row{\r\n    background-color: transparent!important;\r\n}\r\n.customer-user-billing-account-transactions-table-container table th,\r\n.customer-user-billing-account-transactions-table-container table td{\r\n    text-align: left;\r\n    font-size: 16px;\r\n    padding: 5px 10px;\r\n}\r\n.customer-user-billing-account-transactions-table-container table th{\r\n    font-weight: 600;\r\n}\r\n.customer-user-billing-account-transactions-table-container table td{\r\n    font-size: 15px;\r\n}\r\n.customer-user-billing-account-transactions-table-container tr:nth-child(odd){\r\n    background-color: rgba(206, 206, 206,0.953);\r\n}\r\n.customer-user-billing-account-transactions-table-container tr:nth-child(even){\r\n    background-color: rgb(242, 242, 242);\r\n}\r\n/*TOP UP SECTION*/\r\n.customer-user-billing-account-top-up-container{\r\n    max-height: 50vh;\r\n    margin: 4vh 4vw;\r\n    padding: 15px 20px;\r\n    border-radius: 10px;\r\n    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.2);\r\n    opacity: 0;\r\n    transform: translateY(-2vh);\r\n    animation: customer-user-billing-account-top-up-container-fade-in 0.8s forwards;\r\n}\r\n@keyframes customer-user-billing-account-top-up-container-fade-in{\r\n    from{\r\n        opacity: 0;\r\n        transform: translateY(-2vh);\r\n    }\r\n    to{\r\n        opacity: 1;\r\n        transform: translateY(0);\r\n    }\r\n}\r\n.customer-user-billing-account-top-up-navigation-bar{\r\n    padding: 10px 0px;\r\n    border-bottom: 1px solid rgb(221, 221, 221);\r\n}\r\n.customer-user-billing-account-top-up-navigation-bar button{\r\n    margin: 0px 12px;\r\n    padding: 8px 12px;\r\n    border: none;\r\n    border-radius: 5px;\r\n    color: white;\r\n    cursor: pointer;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.5);\r\n    transition: background-color 0.5s ease;\r\n}\r\n.customer-user-billing-account-top-up-navigation-bar button:hover{\r\n    background-color: rgba(196, 37, 37, 0.952);\r\n}\r\n.customer-user-billing-account-top-up-body{\r\n    height: auto;\r\n    margin-top: 4px;\r\n    margin-bottom: 2vh;\r\n}\r\n/**CASH TOP UP**/\r\n.customer-user-billing-account-cash-top-up-entry-container{\r\n    width: 45%;\r\n    margin-left: 4vw;\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n.customer-user-billing-account-cash-top-up-entry-p{\r\n    font-weight: 600;\r\n}\r\n.customer-user-billing-account-cash-top-up-entry-amount-container,\r\n.customer-user-billing-account-cash-top-up-entry-currency-container{\r\n    display: grid;\r\n    grid-template-columns: 2fr 3fr;\r\n    margin-bottom: 20px;\r\n    padding: 5px 0px;\r\n    align-items: center;\r\n}\r\n.customer-user-billing-account-cash-top-up-entry-amount-container p,\r\n.customer-user-billing-account-cash-top-up-entry-currency-container p{\r\n    margin: 0px;\r\n}\r\n.customer-user-billing-account-cash-top-up-entry-amount-container input{\r\n    width: 84%;\r\n    border: none;\r\n    outline: none;\r\n    padding: 10px 16px;\r\n    border-radius: 4px;\r\n    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.35);\r\n}\r\n.customer-user-billing-account-cash-top-up-entry-currency-container select{\r\n    width: 96%;\r\n    margin: 0px;\r\n    padding: 10px;\r\n    outline: none;\r\n    border: none;\r\n    border-radius: 4px;\r\n    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.35);\r\n}\r\n.customer-user-billing-account-cash-top-up-entry-deposit-button-container{\r\n    display: flex;\r\n    justify-content: flex-end;\r\n}\r\n.customer-user-billing-account-cash-top-up-entry-deposit-button-container button{\r\n    margin: 0px 12px;\r\n    padding: 8px 12px;\r\n    border: none;\r\n    border-radius: 5px;\r\n    color: white;\r\n    cursor: pointer;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.5);\r\n    transition: background-color 0.5s ease;\r\n}\r\n.customer-user-billing-account-cash-top-up-entry-deposit-button-container button:hover{\r\n    background-color: rgba(196, 37, 37, 0.952);\r\n}\r\n.customer-user-billing-account-cash-topping-up-container{\r\n    margin: 10vh 0;\r\n    text-align: center;\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n.customer-user-billing-account-cash-topping-up-container .spinner{\r\n    width: 30px;\r\n    height: 30px;\r\n    margin: auto;\r\n    margin-bottom: 10px;\r\n    border: 5px solid rgba(155, 30, 30, 0.952);\r\n    border-top: 5px solid transparent;\r\n    border-radius: 50%;\r\n    animation: customer-billing-account-cash-topping-up-container-spin 1s linear infinite;\r\n}\r\n@keyframes customer-billing-account-cash-topping-up-container-spin {\r\n    0% {transform: rotate(0deg);}\r\n    100% {transform: rotate(360deg);}\r\n}\r\n.customer-user-billing-account-cash-top-up-success-container,\r\n.customer-user-billing-account-cash-top-up-failed-container{\r\n    margin: 50px 0px;\r\n    margin-left: 2vw;\r\n}\r\n.customer-user-billing-account-cash-top-up-success-container .header-paragraph,\r\n.customer-user-billing-account-cash-top-up-failed-container .header-paragraph{\r\n    font-weight: 500;\r\n    color: rgb(155, 30, 30);\r\n}\r\n.customer-user-billing-account-cash-top-up-success-container p,\r\n.customer-user-billing-account-cash-top-up-failed-container p{\r\n    margin: 20px 0px;\r\n}\r\n.customer-user-billing-account-cash-top-up-success-container button{\r\n    margin-right: 25px;\r\n    padding: 10px 16px;\r\n    border: none;\r\n    border-radius: 5px;\r\n    color: white;\r\n    cursor: pointer;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.5);\r\n    transition: background-color 0.5s ease;\r\n}\r\n.customer-user-billing-account-cash-top-up-failed-container button{\r\n    margin-right: 25px;\r\n    padding: 8px 18px;\r\n    border: none;\r\n    border-radius: 5px;\r\n    color: white;\r\n    cursor: pointer;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.5);\r\n    transition: background-color 0.5s ease;\r\n}\r\n.customer-user-billing-account-cash-top-up-success-container button:hover{\r\n    background-color: rgba(196, 37, 37, 0.952);\r\n}\r\n/**MPESA TOP UP**/\r\n.customer-user-billing-account-mpesa-top-up-entry-container{\r\n    width: 48%;\r\n    margin-left: 4vw;\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n.customer-user-billing-account-mpesa-top-up-entry-mobile-number-container,\r\n.customer-user-billing-account-mpesa-top-up-entry-amount-container{\r\n    display: grid;\r\n    grid-template-columns: 0.6fr 1fr;\r\n    margin-bottom: 24px;\r\n    align-items: center;\r\n}\r\n.customer-user-billing-account-mpesa-top-up-entry-mobile-number-container p,\r\n.customer-user-billing-account-mpesa-top-up-entry-amount-container p{\r\n    margin: 0px;\r\n}\r\n.customer-user-billing-account-mpesa-top-up-entry-mobile-number-container label{\r\n    margin-top: 2px;\r\n    color: red;\r\n    grid-column: 2;\r\n    font-size: 14px;\r\n    width: 96%;\r\n    text-align: right;\r\n}\r\n.customer-user-billing-account-mpesa-top-up-entry-mobile-number-container input,\r\n.customer-user-billing-account-mpesa-top-up-entry-amount-container input{\r\n    border: none;\r\n    outline: none;\r\n    padding: 10px 15px;\r\n    border-radius: 10px;\r\n    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.4);\r\n}\r\n.customer-user-billing-account-mpesa-top-up-entry-stk-push-button-container{\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    padding: 10px 0px;\r\n    padding-top: 15px;\r\n}\r\n.customer-user-billing-account-mpesa-top-up-entry-stk-push-button-container button{\r\n    margin: 0px;\r\n    padding: 8px 12px;\r\n    border: none;\r\n    border-radius: 5px;\r\n    color: white;\r\n    cursor: pointer;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.5);\r\n    transition: background-color 0.5s ease;\r\n}\r\n.customer-user-billing-account-mpesa-top-up-entry-stk-push-button-container button:hover{\r\n    background-color: rgba(196, 37, 37, 0.952);\r\n}\r\n.customer-user-billing-account-mpesa-topping-up-container{\r\n    margin: 5vh 0;\r\n    margin-bottom: 10vh;\r\n    text-align: center;\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n.customer-user-billing-account-mpesa-topping-up-container .spinner{\r\n    width: 40px;\r\n    height: 40px;\r\n    margin: auto;\r\n    margin-bottom: 10px;\r\n    border: 5px solid rgba(155, 30, 30, 0.952);\r\n    border-top: 5px solid transparent;\r\n    border-radius: 50%;\r\n    animation: customer-user-billing-account-mpesa-topping-up-spinner 1s linear infinite;\r\n}\r\n@keyframes customer-user-billing-account-mpesa-topping-up-spinner {\r\n    0% {transform: rotate(0deg);}\r\n    100% {transform: rotate(360deg);}\r\n}\r\n.customer-user-billing-account-mpesa-topping-up-container p{\r\n    padding: 10px;\r\n    padding-left: 24px;\r\n    margin: 25px 8vw;\r\n    font-size: 15px;\r\n    cursor: default;\r\n    line-height: 1.4;\r\n    border-radius: 10px;\r\n    color: rgb(51, 51, 51);\r\n    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);\r\n}\r\n.customer-user-billing-account-mpesa-top-up-success-container,\r\n.customer-user-billing-account-mpesa-top-up-failed-container,\r\n.customer-user-billing-account-mpesa-top-up-pending-container{\r\n    margin: 50px;\r\n}\r\n.customer-user-billing-account-mpesa-top-up-success-container .header-paragraph,\r\n.customer-user-billing-account-mpesa-top-up-failed-container .header-paragraph,\r\n.customer-user-billing-account-mpesa-top-up-pending-container .header-paragraph{\r\n    font-weight: 500;\r\n    color: rgb(155, 30, 30);\r\n}\r\n.customer-user-billing-account-mpesa-top-up-success-container p,\r\n.customer-user-billing-account-mpesa-top-up-failed-container p,\r\n.customer-user-billing-account-mpesa-top-up-pending-container p{\r\n    margin: 20px 0px;\r\n}\r\n.customer-user-billing-account-mpesa-top-up-success-container button,\r\n.customer-user-billing-account-mpesa-top-up-failed-container button,\r\n.customer-user-billing-account-mpesa-top-up-pending-container button{\r\n    margin-right: 25px;\r\n    padding: 10px 16px;\r\n    border: none;\r\n    border-radius: 5px;\r\n    color: white;\r\n    cursor: pointer;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.5);\r\n    transition: background-color 0.5s ease;\r\n}\r\n.customer-user-billing-account-mpesa-top-up-success-container button:hover,\r\n.customer-user-billing-account-mpesa-top-up-failed-container button:hover,\r\n.customer-user-billing-account-mpesa-top-up-pending-container button:hover{\r\n    background-color: rgba(196, 37, 37, 0.952);\r\n}\r\n.customer-user-billing-account-mpesa-top-up-failed-container .failure-body-container,\r\n.customer-user-billing-account-mpesa-top-up-pending-container .pending-body-container{\r\n    display: inline-block;\r\n    padding: 10px 15px;\r\n    margin-top: 10px;\r\n    margin-bottom: 35px;\r\n    border-radius: 10px;\r\n    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);\r\n}\r\n.customer-user-billing-account-mpesa-top-up-failed-container .failure-body-container p,\r\n.customer-user-billing-account-mpesa-top-up-pending-container .pending-body-container p{\r\n    margin: 4px 0px;\r\n    font-size: 14px;\r\n    color: rgb(51, 51, 51);\r\n}\r\n/**BANK CHEQUE TOP UP**/\r\n.customer-user-billing-account-bank-cheque-top-up-entry-container-parent{\r\n    padding-bottom: 2vh;\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n.customer-user-billing-account-bank-cheque-top-up-entry-p{\r\n    margin-left: 4vw;\r\n    font-weight: 600;\r\n    margin-bottom: 15px;\r\n}\r\n.customer-user-billing-account-bank-cheque-top-up-entry-container{\r\n    height: auto;\r\n    margin-left: 4vw;\r\n    max-height: 35vh;\r\n    overflow-y: auto;\r\n}\r\n.customer-user-billing-account-bank-cheque-top-up-entry-container::-webkit-scrollbar{\r\n    width: 8px;\r\n}\r\n.customer-user-billing-account-bank-cheque-top-up-entry-container::-webkit-scrollbar-track{\r\n    border-radius: 10px;\r\n    background-color: rgb(201, 201, 201);\r\n}\r\n.customer-user-billing-account-bank-cheque-top-up-entry-container::-webkit-scrollbar-thumb{\r\n    border-radius: 10px;\r\n    background-color: gray;\r\n}\r\n.customer-user-billing-account-bank-cheque-top-up-entry-container-body{\r\n    width: 50%;\r\n}\r\n.customer-user-billing-account-bank-cheque-top-up-entry-bank-name-container,\r\n.customer-user-billing-account-bank-cheque-top-up-entry-cheque-number-container,\r\n.customer-user-billing-account-bank-cheque-top-up-entry-bank-code-container,\r\n.customer-user-billing-account-bank-cheque-top-up-entry-account-number-container,\r\n.customer-user-billing-account-bank-cheque-top-up-entry-amount-container,\r\n.customer-user-billing-account-bank-cheque-top-up-entry-currency-container{\r\n    display: grid;\r\n    grid-template-columns: 0.6fr 1fr;\r\n    margin: 20px 0px;\r\n}\r\n.customer-user-billing-account-bank-cheque-top-up-entry-bank-name-container p,\r\n.customer-user-billing-account-bank-cheque-top-up-entry-cheque-number-container p,\r\n.customer-user-billing-account-bank-cheque-top-up-entry-bank-code-container p,\r\n.customer-user-billing-account-bank-cheque-top-up-entry-account-number-container p,\r\n.customer-user-billing-account-bank-cheque-top-up-entry-amount-container p,\r\n.customer-user-billing-account-bank-cheque-top-up-entry-currency-container p{\r\n    margin: 0px;\r\n}\r\n.customer-user-billing-account-bank-cheque-top-up-entry-bank-name-container input,\r\n.customer-user-billing-account-bank-cheque-top-up-entry-cheque-number-container input,\r\n.customer-user-billing-account-bank-cheque-top-up-entry-bank-code-container input,\r\n.customer-user-billing-account-bank-cheque-top-up-entry-account-number-container input,\r\n.customer-user-billing-account-bank-cheque-top-up-entry-amount-container input,\r\n.customer-user-billing-account-bank-cheque-top-up-entry-currency-container input{\r\n    border: none;\r\n    outline: none;\r\n    padding: 10px 15px;\r\n    border-radius: 4px;\r\n    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.35);\r\n}\r\n.customer-user-billing-account-bank-cheque-top-up-entry-currency-container select{\r\n    width: 98%;\r\n    margin: 0px;\r\n    padding: 10px;\r\n    outline: none;\r\n    border: none;\r\n    border-radius: 4px;\r\n    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.35);\r\n}\r\n.customer-user-billing-account-bank-cheque-top-up-entry-deposit-button-container{\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    margin-bottom: 10px;\r\n}\r\n.customer-user-billing-account-bank-cheque-top-up-entry-deposit-button-container button{\r\n    margin: 0px;\r\n    padding: 8px 12px;\r\n    border: none;\r\n    border-radius: 5px;\r\n    color: white;\r\n    cursor: pointer;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.5);\r\n    transition: background-color 0.5s ease;\r\n}\r\n.customer-user-billing-account-bank-cheque-top-up-entry-deposit-button-container button:hover{\r\n    background-color: rgba(196, 37, 37, 0.952);\r\n}\r\n.customer-user-billing-account-bank-cheque-topping-up-container{\r\n    margin-top: 5vh;\r\n    margin-bottom: 8vh;\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n.customer-user-billing-account-bank-cheque-topping-up-container div{\r\n    text-align: center;\r\n}\r\n.customer-user-billing-account-bank-cheque-topping-up-container div .spinner{\r\n    width: 40px;\r\n    height: 40px;\r\n    margin: auto;\r\n    margin-bottom: 10px;\r\n    border: 5px solid rgba(155, 30, 30, 0.952);\r\n    border-top: 5px solid transparent;\r\n    border-radius: 50%;\r\n    animation: customer-user-billing-account-bank-cheque-topping-up-spin 1s linear infinite;\r\n}\r\n@keyframes customer-user-billing-account-bank-cheque-topping-up-spin {\r\n    0%{transform: rotate(0deg);}\r\n    100%{transform: rotate(360deg);}\r\n}\r\n.customer-user-billing-account-bank-cheque-top-up-success-container,\r\n.customer-user-billing-account-bank-cheque-top-up-failed-container{\r\n    margin: 40px 20px;\r\n}\r\n.customer-user-billing-account-bank-cheque-top-up-success-container .header-paragraph,\r\n.customer-user-billing-account-bank-cheque-top-up-failed-container .header-paragraph{\r\n    font-weight: 500;\r\n    color: rgb(155, 30, 30);\r\n}\r\n.customer-user-billing-account-bank-cheque-top-up-success-container p,\r\n.customer-user-billing-account-bank-cheque-top-up-failed-container p{\r\n    margin: 20px 0px;\r\n}\r\n.customer-user-billing-account-bank-cheque-top-up-success-container button{\r\n    margin-right: 25px;\r\n    padding: 10px 16px;\r\n    border: none;\r\n    border-radius: 5px;\r\n    color: white;\r\n    cursor: pointer;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.5);\r\n    transition: background-color 0.5s ease;\r\n}\r\n.customer-user-billing-account-bank-cheque-top-up-failed-container button{\r\n    margin-right: 25px;\r\n    padding: 8px 18px;\r\n    border: none;\r\n    border-radius: 5px;\r\n    color: white;\r\n    cursor: pointer;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.5);\r\n    transition: background-color 0.5s ease;\r\n}\r\n.customer-user-billing-account-bank-cheque-top-up-success-container button:hover,\r\n.customer-user-billing-account-bank-cheque-top-up-failed-container button:hover{\r\n    background-color: rgba(196, 37, 37, 0.952);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
